var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7487 3.25H19.2487C19.755 3.25 20.1654 3.66041 20.1654 4.16667V18.8333C20.1654 19.3396 19.755 19.75 19.2487 19.75H2.7487C2.24244 19.75 1.83203 19.3396 1.83203 18.8333V4.16667C1.83203 3.66041 2.24244 3.25 2.7487 3.25ZM18.332 7.13476L11.0645 13.6432L3.66536 7.11461V17.9167H18.332V7.13476ZM4.1342 5.08333L11.0554 11.1902L17.8746 5.08333H4.1342Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.5aa9bbfa07b9acde10ff19e788de75cd.svg";
export { ForwardRef as ReactComponent };